const FormResources = {

    form_data:{
        daily_assignment_id:            '',
        associate_id:                   '',
        date:                           new Date().toLocaleDateString('pt-br').split('/').reverse().join('-'),
        discharge_beds_count:           0,
        over_time_minutes:              0,
        work_reduction_time:            0,
        project_time:                   0,
        pages_minutes_count:            0,
        pages_minutes:                  0,
        other_assignments:              0,
        include_productivity:           false,
        meeting_setups_minutes:         0,
        meeting_setups_minutes_count:   0,
        move_minutes:                   0,
        non_evs_minutes:                0,
        minutes_available_calc:         0,
        productivity_percentage_calc:   0,
        discharge_capability_calc:      0,
        overall_census_calc:            0,
        cath_lab_cases:                 0,
        cath_lab_cases_count:           0,
        cath_lab_in_between:            0,
        cath_lab_in_between_count:      0,
        or_in_between:                  0,
        or_in_between_count:            0,
        triagle_in_between:             0,
        triagle_in_between_count:       0,
        ed_in_between:                  0,
        ed_in_between_count:            0,
        notes:                          '',
    },

    form_data_discharges: {
        bed_id: []
    },

    form_format_lite:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
            label:      'associate_name'
        },
    ],

    first_form_format:[
            {
                fields:
                [  
                    {
                        css_class:  'col-md-3',
                        type:       'date',
                        maxlength:  '',
                        disabled:   false,
                        step:       '',
                        name:       'Date:',
                        model_name: 'date',
                        ref:        'date_input',
                        ref_alt:    'date_input_alt',
                        required:   true,
                    },
                    {
                        css_class:  'col-md-3',
                        type:       'select',
                        maxlength:  '',
                        disabled:   false,
                        step:       '',
                        name:       'Assignment:',
                        model_name: 'daily_assignment_id',
                        ref:        'daily_assignment_id_input',
                        ref_alt:    'daily_assignment_id_input_alt',
                        required:   true,
                        max_width: '100%'
                    },
                ]
            },
       
    ],

    second_form_format:[
        {
            fields:
            [    
                {
                    css_class:  'col-md-4',
                    type:       'select',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       'Associate:',
                    model_name: 'associate_id',
                    ref:        'associate_id_input',
                    ref_alt:    'associate_id_input_alt',
                    required:   true,
                    max_width:   '85%',
                    label:      'associate_name'
                },
            ]
        },
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Discharges Cleaned:',
                    model_name: 'discharge_beds_count',
                    ref:        'discharge_beds_count_input',
                    ref_alt:    'discharge_beds_count_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Other Assignments:',
                    model_name: 'other_assignments',
                    ref:        'other_assignments_input',
                    ref_alt:    'other_assignments_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Non EVS Minutes:',
                    model_name: 'non_evs_minutes',
                    ref:        'evs_minutes_input',
                    ref_alt:    'evs_minutes_input_alt',
                    required:   false,
                },
            ]
        },
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Over Time Minutes:',
                    model_name: 'over_time_minutes',
                    ref:        'over_time_minutes_input',
                    ref_alt:    'over_time_minutes_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Meeting Setups (Count):',
                    model_name: 'meeting_setups_minutes_count',
                    ref:        'meeting_setups_minutes_count_input',
                    ref_alt:    'meeting_setups_minutes_count_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Number of Pages:',
                    model_name: 'pages_minutes_count',
                    ref:        'pages_minutes_count_input',
                    ref_alt:    'pages_minutes_count_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]
        },
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Work Reduction Time:',
                    model_name: 'work_reduction_time',
                    ref:        'work_reduction_time_input',
                    ref_alt:    'work_reduction_time_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                css_class:  'col-md-4',
                type:       'number',
                maxlength:  '',
                disabled:   false,
                step:       'any',
                name:       'Meeting Setups (Minutes):',
                model_name: 'meeting_setups_minutes',
                ref:        'meeting_setups_minutes_input',
                ref_alt:    'meeting_setups_minutes_input_alt',
                required:   false,
                max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Pages (Minutes):',
                    model_name: 'pages_minutes',
                    ref:        'pages_minutes_input',
                    ref_alt:    'pages_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                // {
                //     css_class:  'col-md-4',
                //     type:       'number',
                //     maxlength:  '',
                //     disabled:   false,
                //     step:       'any',
                //     name:       'Other Assignments:',
                //     model_name: 'other_assignments',
                //     ref:        'other_assignments_input',
                //     ref_alt:    'other_assignments_input_alt',
                //     required:   false,
                //     max_width:   '100%'
                // },
            ]
        },
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Project Time:',
                    model_name: 'project_time',
                    ref:        'project_time_input',
                    ref_alt:    'project_time_input_alt',
                    required:   false,
                    max_width:   '60%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Move Minutes:',
                    model_name: 'move_minutes',
                    ref:        'move_minutes_input',
                    ref_alt:    'move_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       'Include in Productivity:',
                    model_name: 'include_productivity',
                    ref:        'include_productivity_input',
                    ref_alt:    'include_productivity_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
            max_width:   '100%'
        },
    ],
    third_form_format:
    [
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    calculated: true,
                    step:       'any',
                    name:       'Minutes Available:',
                    model_name: 'minutes_available_calc',
                    ref:        'minutes_available_calc_input',
                    ref_alt:    'minutes_available_calc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    calculated: true,
                    step:       'any',
                    name:       'Discharge Capability:',
                    model_name: 'discharge_capability_calc',
                    ref:        'discharge_capability_calc_input',
                    ref_alt:    'discharge_capability_calc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    calculated: true,
                    step:       'any',
                    name:       'Productivity %:',
                    model_name: 'productivity_percentage_calc',
                    ref:        'productivity_percentage_calc_input',
                    ref_alt:    'productivity_percentage_calc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]
        },
        {
            fields:
            [
                {
                    css_class:  'col-md-4',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    calculated: true,
                    step:       'any',
                    name:       'Assignment Census %:',
                    model_name: 'assignment_census',
                    ref:        'assignment_census_input',
                    ref_alt:    'assignment_census_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-4',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    calculated: true,
                    step:       'any',
                    name:       'Overall Census %:',
                    model_name: 'overall_census_calc',
                    ref:        'overall_census_calc_input',
                    ref_alt:    'overall_census_calc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]
        },
    ],

    fourth_form_format:[
        {
            name: 'Cath Lab Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'cath_lab_cases_count',
                    ref:        'cath_lab_case_number_input',
                    ref_alt:    'cath_lab_case_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_cases',
                    ref:        'cath_lab_case_total_minutes_input',
                    ref_alt:    'cath_lab_case_total_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]

        },
        {
            name: 'Cath Lab In Between',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab in Between Total Numbers:',
                    model_name: 'cath_lab_in_between_count',
                    ref:        'cath_lab_between_number_input',
                    ref_alt:    'cath_lab_between_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab in Between Total Minutes:',
                    model_name: 'cath_lab_in_between',
                    ref:        'cath_lab_between_total_minutes_input',
                    ref_alt:    'cath_lab_between_total_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]

        },
        {
            name: 'OR In Between',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Or Between Number:',
                    model_name: 'or_in_between_count',
                    ref:        'or_between_number_input',
                    ref_alt:    'or_between_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Or Between Total Number:',
                    model_name: 'or_in_between',
                    ref:        'or_between_total_number_input',
                    ref_alt:    'or_between_total_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]

        },
        {
            name: 'Triagle In Between',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Triagle Between Number:',
                    model_name: 'triagle_in_between_count',
                    ref:        'triage_between_number_input',
                    ref_alt:    'triage_between_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Triagle Between Total Minutes:',
                    model_name: 'triagle_in_between',
                    ref:        'triage_between_total_number_input',
                    ref_alt:    'triage_between_total_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]

        },
        {
            name: 'ED In Between',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Ed Between Number:',
                    model_name: 'ed_in_between_count',
                    ref:        'ed_between_number_input',
                    ref_alt:    'ed_between_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Ed Between Total Minutes:',
                    model_name: 'ed_in_between',
                    ref:        'ed_between_total_number_input',
                    ref_alt:    'ed_between_total_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
            ]

        }
    ],

    form_format_discharges: [
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Bed codes:',
            model_name: 'bed_id',
            ref:        'bed_id_input',
            ref_alt:    'bed_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select bed code(s)',
            close_on_option: false,
            track_by: 'bed_code'
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Minutes:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
            max_width:   '100%'
        },
    ]
}

export default FormResources;